__turbopack_context__.v({
  "bmcOverlay": "PhotoModalViewer-module__hWx1UW__bmcOverlay",
  "caption": "PhotoModalViewer-module__hWx1UW__caption",
  "captionText": "PhotoModalViewer-module__hWx1UW__captionText",
  "errorPlaceholder": "PhotoModalViewer-module__hWx1UW__errorPlaceholder",
  "image": "PhotoModalViewer-module__hWx1UW__image",
  "imageFrame": "PhotoModalViewer-module__hWx1UW__imageFrame",
  "next": "PhotoModalViewer-module__hWx1UW__next",
  "overlayButton": "PhotoModalViewer-module__hWx1UW__overlayButton",
  "prev": "PhotoModalViewer-module__hWx1UW__prev",
  "toolbar": "PhotoModalViewer-module__hWx1UW__toolbar",
  "video": "PhotoModalViewer-module__hWx1UW__video",
  "viewer": "PhotoModalViewer-module__hWx1UW__viewer",
});
